import { Box, Image } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useState } from 'react'
import { AppModal } from './AppModal'

export interface StreetViewCardProps {
  address: {
    latitude?: string | null
    longitude?: string | null
    streetViewCameraLat?: string | null
    streetViewCameraLng?: string | null
    streetViewHeading?: string | null
  }
  apiKey: string
}

export function StreetViewCard({ address, apiKey }: StreetViewCardProps) {
  const [opened, { open, close }] = useDisclosure(false)
  const [imageError, setImageError] = useState(false)

  // Check if we have camera location and heading from database
  const hasStreetViewData =
    address.streetViewCameraLat &&
    address.streetViewCameraLng &&
    address.streetViewHeading

  // If no Street View data in database, don't show the component
  if (!hasStreetViewData) {
    return null
  }

  const cameraLat = address.streetViewCameraLat
  const cameraLng = address.streetViewCameraLng
  const heading = address.streetViewHeading

  // Google Street View Static API URL
  const staticImageUrl = `https://maps.googleapis.com/maps/api/streetview?size=600x400&location=${cameraLat},${cameraLng}&fov=90&heading=${heading}&pitch=0&key=${apiKey}`

  // Google Street View Embed URL for interactive mode
  const embedUrl = `https://www.google.com/maps/embed/v1/streetview?location=${cameraLat},${cameraLng}&heading=${heading}&key=${apiKey}`

  // If image failed to load, Street View is not available - hide component
  if (imageError) {
    return null
  }

  return (
    <>
      <Image
        src={staticImageUrl}
        alt="Kiinteistön katunäkymä"
        onError={(error) => {
          console.error(error)
          setImageError(true)
        }}
        onClick={open}
        style={{
          width: '100%',
          height: 'auto',
          aspectRatio: '3/2',
        }}
        bdrs={'md'}
      />

      {/* Interactive Street View Modal */}
      <AppModal
        opened={opened}
        onClose={close}
        title="Katunäkymä"
        size="90%"
        showFooter={false}
        withGradient={false}
        padding="0"
      >
        <Box
          component="iframe"
          src={embedUrl}
          style={{
            width: '100%',
            height: '70vh',
            border: 'none',
            borderRadius: 'var(--mantine-radius-md)',
          }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Street View"
        />
      </AppModal>
    </>
  )
}
